import { render, staticRenderFns } from "./beDistributed.vue?vue&type=template&id=d46dbb0c&scoped=true&"
import script from "./beDistributed.vue?vue&type=script&lang=js&"
export * from "./beDistributed.vue?vue&type=script&lang=js&"
import style0 from "./beDistributed.vue?vue&type=style&index=0&lang=less&"
import style1 from "./beDistributed.vue?vue&type=style&index=1&id=d46dbb0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46dbb0c",
  null
  
)

export default component.exports